/* unplugin-vue-components disabled */import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=6b4a6192&lang=less"

const __exports__ = script;

export default __exports__